/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reading_Class_BodyInputs */

const en_reading_class_body = /** @type {(inputs: Reading_Class_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Main text`)
};

const es_reading_class_body = /** @type {(inputs: Reading_Class_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texto principal`)
};

/**
* | output |
* | --- |
* | "Main text" |
*
* @param {Reading_Class_BodyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const reading_class_body = /** @type {((inputs?: Reading_Class_BodyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reading_Class_BodyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_reading_class_body(inputs)
	return en_reading_class_body(inputs)
});